// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__s4N3W","lds-ellipsis1":"Loader_lds-ellipsis1__SCk17","lds-ellipsis2":"Loader_lds-ellipsis2__ByGci","lds-ellipsis3":"Loader_lds-ellipsis3__Zue9t"};